export const isCrawler: boolean = typeof navigator !== 'undefined' &&
  /bot|googlebot|crawler|spider|robot|chrome-lighthouse|google page speed|crawling|yandex|baiduspider/i.test(navigator.userAgent);